import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import PropTypes from 'prop-types';

const ConfirmBox = ({
  modalTitle = 'Confirmation',
  ConfirmButtonText = 'Confirm',
  children,
  handleSubmit,
  cancelDeleteItem
}) => {

  return (
    <Modal
      show={true}
      onHide={() => {}}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header className="text-center disclaimer-header">
        <Modal.Title className="w-100">{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>{children}</div>
       
      </Modal.Body>
      <Modal.Footer>
        <p className="text-center">
          <button
            className="btn btn-secondary mr-2"
            onClick={cancelDeleteItem}
          >
            Cancel
          </button>
          <button
            className="btn btn-branding"
            onClick={handleSubmit}
          >
            {ConfirmButtonText}
          </button>
        </p>
      </Modal.Footer>
    </Modal>
  );
};

ConfirmBox.propTypes = {
  modalTitle: PropTypes.string,
  CancelButtonText: PropTypes.string,
  ConfirmButtonText: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    .isRequired
};

export default ConfirmBox;
